import { render } from "./EventItem.vue?vue&type=template&id=224ec53c&ts=true"
import script from "./EventItem.vue?vue&type=script&lang=ts"
export * from "./EventItem.vue?vue&type=script&lang=ts"

import "./EventItem.vue?vue&type=style&index=0&id=224ec53c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__